export const REQUEST_INIT_DATA = 'REQUEST_INIT_DATA';
export const RECEIVE_INIT_DATA = 'RECEIVE_INIT_DATA';

// ACTION CREATORS
export const requestInitData = () => ({ type: REQUEST_INIT_DATA });
export const receiveInitData = data => ({ type: RECEIVE_INIT_DATA, data });
